// extracted by css-extract-rspack-plugin
export default {"screenerThemed":"screenerThemed-JEkvQv","customiseColumnsAnchor":"customiseColumnsAnchor-WABw21"};